const order = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
  // mon: 0,
  // tue: 1,
  // wed: 2,
  // thu: 3,
  // fri: 4,
  // sat: 5,
  // sun: 6,
};

export default function (days) {
  return Object.values(days).sort((a, b) => order[a.day] - order[b.day]);
}
